module.exports = __webpack_public_path__ + "img/rank_top1_en.67871519.png";